import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { css } from "styled-components";

Object.assign(addToCartButtonStyles, {
    button: {
        variant: "primary",
        sizeVariant: "large",
        css: css`
            width: 100%;
        `,
    },
});
